import { getRecordList, getMediaUrl, getImageUrl } from '@src/utils/media-data';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import TopMenuStore from '@src/business-components/top-menu/store';
import { observable } from 'mobx';
import OrderTipsModalStore from '@src/business-components/order-tips-modal/store';
import OrderModalStore from '@src/business-components/order-modal/store';
import OrderSuccessModalStore from '@src/business-components/order-success-modal/store';
import GiftRuleModalStore from '@src/business-components/gift-rule-modal/store';
import KVStore from './components/kv/store';
import { go } from '@src/utils/promise';
import Toast from '@src/components/toast';
import Part4Store from './components/part4/store';
import { getOmniData, Ids } from '@src/services/omni-api';
import deviceUtils from '@src/utils/device-utils';
import { getParameterByNames } from '@src/utils/common-util';
import $$tracker from '@src/tracker';

class MainStore extends BaseStore {
  topMenuStore = new TopMenuStore();
  /** 游戏阶段 预约阶段-appointment 预下载阶段-pre_download 公测阶段-beta_download */
  @observable game_stage_config;
  /** KV 区域视频链接 */
  @observable kvVideoUrl = '';
  /** 下载链接 */
  @observable downloadUrl = null;
  /** 充值链接 */
  @observable chargeUrl = null;
  /** 用户信息，配置信息 如登录用户的手机号 */
  @observable projectConfig;
  topMenuStore = new TopMenuStore({ mainStore: this });
  KVStore = new KVStore({ mainStore: this });
  part4Store = new Part4Store({ mainStore: this });

  orderTipsModalStore = new OrderTipsModalStore({
    isOpen: false,
    isActive: false
  });
  orderModalStore = new OrderModalStore({
    isOpen: false,
    isActive: false,
    successCallBack: () => this.getConfig(),
    openOrderTipsModalStore: () => {
      this.orderModalStore.isOpen = false;
      this.orderModalStore.isActive = false;

      this.orderTipsModalStore.isOpen = true;
      this.orderTipsModalStore.isActive = true;
      $$tracker.clickPopupQrcodeReservation();
    }
  });
  // click_go_reservation
  orderSuccessModalStore = new OrderSuccessModalStore({
    isOpen: false,
    isActive: false
  });
  giftRuleModalStore = new GiftRuleModalStore({
    isOpen: false,
    isActive: false
  });

  websiteUrl = 'https://js4.seasungames.cn/m/index/index.html';

  /**
   * 链接列表
   */
  linkList = [
    {
      name: '微信公众号',
      url: 'https://js4.seasungames.cn/m/index.html?utm_source=wxgzh',
      shortUrl: 'https://s.seasungames.com/rW5Cjc'
    },
    {
      name: '官方抖音',
      url: '',
      shortUrl: ''
    },
    {
      name: '客服管家',
      url: '',
      shortUrl: ''
    },
    {
      name: '游戏微博',
      url: 'https://js4.seasungames.cn/m/index.html?utm_source=wb',
      shortUrl: 'https://s.seasungames.com/rW5CtF'
    }
  ];

  /**
   * 打开预约提示弹窗
   */
  openOrderTipsModal = () => {
    this.orderTipsModalStore.isOpen = true;
    this.orderTipsModalStore.isActive = true;
  };

  /** 打开现金红包活动规则弹窗 */
  openGiftRuleModal = () => {
    this.giftRuleModalStore.isOpen = true;
    this.giftRuleModalStore.isActive = true;
  };

  /**
   * 打开预约弹窗
   */
  openOrderModal = () => {
    // 先关闭预约提示弹窗
    this.orderTipsModalStore.isOpen = false;
    this.orderTipsModalStore.isActive = false;
    // 打开预约弹窗
    this.orderModalStore.isOpen = true;
    this.orderModalStore.isActive = true;
  };
  /**
   * 获取预约人数，使用cms-api获取
   */
  getOrderCount = async () => {};

  /** 获取项目配置 */
  getConfig = async () => {
    const [config, err] = await go(this.$ztService.getConfig());
    if (err) {
      err.message && Toast.fail(err.message);
      return;
    }
    this.projectConfig = config;
  };
  /** 获取阶段配 */
  getOminStage = async () => {
    const [res, err] = await go(getOmniData(Ids.kv.channel, [{ dataSourceId: Ids.kv.dataSources.stage || '', page: 1, perPage: 99 }]));
    if (err) {
      err.message && Toast.fail(err.message);
      return;
    }
    // 解析游戏阶段
    const stageItems = res?.[Ids.kv.dataSources.stage]?.result?.items?.[0];
    this.game_stage_config = stageItems?.game_stage_config || '';
    /** 游戏阶段 预约阶段-appointment 预下载阶段-pre_download 公测阶段-beta_download */
    // this.game_stage_config = 'appointment';
  };

  /** 获取下载地址信息 */
  getDownloadInfo = async () => {
    const utmSource = getParameterByNames('utm_source');
    // 默认链接
    let dataSources = [{ dataSourceId: Ids.kv.dataSources.default_download || '', page: 1, perPage: 99 }];
    // 推广渠道链接
    if (utmSource) {
      dataSources.push({
        dataSourceId: Ids.kv.dataSources.custom_download || '',
        contentFilter: { relation: 'and', items: [{ field: 'utm_source', operator: 'eq', value: utmSource }] }
      });
    }
    const [res, err] = await go(getOmniData(Ids.kv.channel, dataSources));
    if (err) return;

    // 默认下载链接
    const defaultLinkItems = getRecordList(res?.[Ids.kv.dataSources.default_download]?.result?.items);
    // 渠道下载链接
    const sourceLinkItems = getRecordList(res?.[Ids.kv.dataSources.custom_download]?.result?.items);
    console.log('getDownloadInfo', { defaultLinkItems, sourceLinkItems });

    const downLinkMap = defaultLinkItems.reduce((acc, item) => {
      acc[item.download_channel_code] = getImageUrl(item.download_link?.url) || getMediaUrl(item.channel_qrcode);
      return acc;
    }, {});
    this.chargeUrl = downLinkMap.charge;

    // 配置下载链接，优先使用渠道链接
    if (utmSource && sourceLinkItems.length > 0) {
      this.downloadUrl = getImageUrl(sourceLinkItems[0]?.download_link?.url);
      return;
    }
    // 使用默认链接
    if (deviceUtils.isAndroid()) {
      this.downloadUrl = downLinkMap.android;
    } else if (deviceUtils.isIOS()) {
      this.downloadUrl = downLinkMap.apple;
    }
  };

  use() {
    super.use();
    useMount(async () => {
      this.getOminStage();
      this.getConfig();
      this.getDownloadInfo();

      // const initFooter = () => {
      //   if (window.init_OMNI__COMMON__FOOTER) {
      //     window.init_OMNI__COMMON__FOOTER();
      //   } else {
      //     // 如果还没加载完，等待一段时间后重试
      //     setTimeout(initFooter, 100);
      //   }
      // };

      // initFooter();

      window.init_OMNI__COMMON__FOOTER();

      // // 打开预约弹窗
      // this.orderModalStore.isOpen = true;
      // this.orderModalStore.isActive = true;
    });
  }
}

export default MainStore;
